import { I18nService } from '../i18n/I18nService';
import { I18N_KEYS } from '../i18n/keys';

export class AccessibilityManager {
  private i18n: I18nService;
  private liveRegion: HTMLElement | null = null;

  constructor(i18n: I18nService) {
    this.i18n = i18n;
  }

  initialize(): void {
    this.liveRegion = document.getElementById('sr-announcements');
    if (!this.liveRegion) {
      this.liveRegion = document.createElement('div');
      this.liveRegion.id = 'sr-announcements';
      this.liveRegion.setAttribute('aria-live', 'assertive');
      this.liveRegion.setAttribute('aria-atomic', 'true');
      this.liveRegion.className = 'visually-hidden';
      document.body.appendChild(this.liveRegion);
    }
  }

  announceNumber(number: number): void {
    if (!this.liveRegion) return;
    const text = this.i18n.t(I18N_KEYS.A11Y_NUMBER_CALLED, { number });
    this.liveRegion.textContent = text;
  }

  announceGameComplete(count: number, time: string): void {
    if (!this.liveRegion) return;
    const text = this.i18n.t(I18N_KEYS.A11Y_GAME_COMPLETE, { count, time });
    this.liveRegion.textContent = text;
  }

  announce(message: string): void {
    if (!this.liveRegion) return;
    this.liveRegion.textContent = message;
  }

  updateGridCellLabel(cell: HTMLElement, number: number, called: boolean): void {
    const key = called ? I18N_KEYS.A11Y_CELL_CALLED : I18N_KEYS.A11Y_CELL_NOT_CALLED;
    cell.setAttribute('aria-label', this.i18n.t(key, { number }));
  }
}
